import { IonImg } from "@ionic/react";
import React from "react";
import { PAYMENT_CARDS_LOGO } from "../../../assets/logos";

interface PaymentCardLogoProps {
  cardType?: string;
  cardLastFour?: string;
}

const PaymentCardLogo: React.FC<PaymentCardLogoProps> = ({ cardType, cardLastFour }) => {
  const cardLogo = cardType ? PAYMENT_CARDS_LOGO[cardType.toLowerCase()] : null;

  return (
    <div className="flex items-center gap-2">
      {cardLogo && <IonImg src={cardLogo} alt={cardType} className="w-12 h-8 object-contain" />}
      {cardLastFour && <span className="tracking-widest">Карта •••• {cardLastFour}</span>}
    </div>
  );
};

export default PaymentCardLogo;
